import { render, staticRenderFns } from "./ChemicalReactionsTestQuestion.vue?vue&type=template&id=2d64ae29&"
import script from "./ChemicalReactionsTestQuestion.vue?vue&type=script&lang=js&"
export * from "./ChemicalReactionsTestQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAlert,VForm})
